import Card_right from "../components/CardRight";

export default function Onskeliste() {
  return (
      <Card_right >
          <div className="card-right-title">
            Ønskeliste
          </div>
          <div className="card-right-content">
          <p>
            Vi er selvfølgelig bare glade for at dere velger å feire denne dagen sammen med oss!  <br/><br/>
            Men om dere lurer på hva vi ønsker oss har vi laget denne <span> </span>

            <a
              href="https://onsk.no/lister/ny4-eoo?s=441215"
              target="_blank"
              rel="noopener noreferrer"
            >
            ønskelisten
            </a>
            .
                      </p>
          </div>
      </Card_right>
  );
}